"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/card/examples/index.ts';
var elevations = ['0', '1', '2', '3', '4'];
var CardExample = /** @class */ (function () {
    function CardExample() {
        this.elevation = 1;
        this.interactive = false;
    }
    CardExample.prototype.view = function () {
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), center: true, src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.Card, {
                elevation: this.elevation,
                fluid: this.fluid,
                interactive: this.interactive,
                size: this.size,
                style: 'min-width: 300px'
            }, (0, mithril_1.default)('h4', 'Card title'), (0, mithril_1.default)('', 'Card content'))
        ]);
    };
    CardExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)('h5', 'Size'),
            (0, mithril_1.default)(examples_1.SizeSelect, {
                value: this.size,
                onSelect: function (size) { return _this.size = size; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                label: 'Interactive',
                onchange: function () { return _this.interactive = !_this.interactive; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                label: 'Fluid',
                onchange: function () { return _this.fluid = !_this.fluid; }
            }),
            (0, mithril_1.default)('h5', 'Elevation'),
            (0, mithril_1.default)(_1.RadioGroup, {
                options: elevations,
                value: this.elevation.toString(),
                onchange: function (e) { return _this.elevation = parseInt(e.currentTarget.value); }
            })
        ];
    };
    return CardExample;
}());
exports.CardExample = CardExample;
